export default Object.freeze({
  UserRequest: '/user/userRequest',
});
